'use client';

import { resolveHref } from '@/utils/pathName';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function LinkLocalized({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children?: React.ReactNode;
}) {
  const pathName = usePathname() ?? '';
  const resolvedHref = resolveHref(pathName, href);

  return (
    <Link href={resolvedHref} className={className}>
      {children}
    </Link>
  );
}
